import React, {Component} from 'react';
import {connect} from 'react-redux';
import { authSelectors} from "../../store/auth";
import {withFirebase} from "../Firebase";
import Sidebar from './Sidebar'
import Geolocation from '../../Services/Geolocation';

function mapStateToProps(state) {
	return {
		loading: authSelectors.isLoading(state.auth)

	};
}

const locationService = new Geolocation();
class SidebarContainer extends Component {
	state = {
		is_panic : false,
		hideSidebar: false,
		permissionPopupVisible: false,
		security_phone: null
	}

	componentDidMount() {
		//this.fetchPanicStatus();
		//this.fetchSecurityPhoneNumber();
	}

	fetchPanicStatus = async () => {
		const { profile, isFaculty } = this.props;
		let profileRef;
		if(isFaculty) {
			profileRef = await this.props.firebase.faculty(profile.id).get();
		} else {
			profileRef = await this.props.firebase.student(profile.id).get();
		}
		let is_panic = profileRef.data() && profileRef.data().is_panic ? true : false;
		this.setState({is_panic});
		if(is_panic)
			locationService.watchPosition(profile.id, isFaculty);
	}

	fetchSecurityPhoneNumber = () => {
		if(this.props.school) {
			const { security_phone } = this.props.school;
			this.setState({security_phone})
		}
	}

	componentWillUnmount() {	
	}

	_toggleConfirmPanicPopup = () => {
		const { hideSidebar } = this.state;
		this.setState({ hideSidebar: !hideSidebar});
	}

	_handlePanicEvent = async () => {
		/* const { profile, isFaculty } = this.props;
		const { is_panic } = this.state;
		try {
			if(is_panic) {
				if(isFaculty) {
					await this.props.firebase.faculty(profile.id).update({
						is_panic: false,
						panic_already_notified: false
					})
				} else {
					await this.props.firebase.student(profile.id).update({
						is_panic: false,
						panic_already_notified: false
					})
				}
				this.setState({is_panic: false});
				locationService.cancelWatchLocation();
			} else {
				const current = new Date();
				const panic_pressed_time = current.toLocaleString('en-US', { timeZone: 'America/New_York', hour12: false }).toString() + ' EST';
				// test
				const position = await locationService.getCurrentLocation();
				console.log('currentPosition: ', position);
				if(isFaculty) {
					await this.props.firebase.faculty(profile.id).update({
						is_panic: true,
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
						panic_pressed_time
					});
				} else {
					await this.props.firebase.student(profile.id).update({
						is_panic: true,
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
						panic_pressed_time
					});
				}

				this.setState({is_panic: true});
				locationService.watchPosition(profile.id, isFaculty);
			}
		} catch(err) {
			console.log(err);
		} */

		/**
		 * Initialize Call with Security Number
		 */

	}

	_handlePressPanic = () => {
		if(locationService.getLocationPermission()) { 
			this._handlePanicEvent();
		}
		else {
			this._popupPermissionPopupToggle();
		}
	}

	_popupPermissionPopupToggle = () => {
		const { permissionPopupVisible } = this.state;
		this.setState({permissionPopupVisible : !permissionPopupVisible});
	}
	
	_handlePermissionConfirm = () => {
		this._handlePanicEvent();
		locationService.setLocationEnabled();
	}

	render() {
		return (
			<Sidebar
				{...this.props}
				{...this.state}
				toggleConfirmPanicPopup={this._toggleConfirmPanicPopup}
				handlePanicEvent={this._handlePanicEvent}
				handlePressPanic={this._handlePressPanic}
				popupPermissionPopupToggle={this._popupPermissionPopupToggle}
				handlePermissionConfirm={this._handlePermissionConfirm}
			/>
		);
	}
}

export default withFirebase(connect(
	mapStateToProps
)(SidebarContainer));